import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-message">
      <h1>Payment Canceled</h1>
      <p>Your payment was not completed.</p>
      <button onClick={() => navigate('/')}>Return to App</button>
    </div>
  );
};

export default PaymentCancel;
